import { useMutation } from '@tanstack/react-query';
import { supabase } from '../../api';

type User = {
  phone?: string;
  email?: string;
  username?: string;
};

const getIsUserWithFieldExists = async (field: string, value: string) => {
  if (!value) return false;
  const { data } = await supabase
    .from('user_profiles')
    .select('*')
    .eq(field, value)
    .maybeSingle();

  return data;
};

const getIsUserExists = async ({
  phone = '',
  email = '',
  username = '',
}: User) => {
  const emailExists = await getIsUserWithFieldExists('email', email);

  // @ts-ignore
  if (emailExists) {
    if (emailExists?.is_deleted) { return 'deleted'; }
    return true;
  }
  const phoneExists = await getIsUserWithFieldExists(
    'phone',
    (phone || '').replace(/\D/g, ''),
  );
  if (phoneExists) {
    if (phoneExists?.is_deleted) { return 'deleted'; }
    return true;
  }
  const usernameExists = await getIsUserWithFieldExists('username', username);
  if (usernameExists) {
    if (usernameExists?.is_deleted) { return 'deleted'; }
    return true;
  }
  return false;
};

export default function useCheckIfUserExists(data: User) {
  return useMutation(() => getIsUserExists(data));
}
